import React, { Component } from "react";
import {
  getSplitQueueState,
  promoteToSplitQueue,
  releaseFromSplitQueue,
  isPromotedInRow,
} from "../util/splitQueue";

const PLATFORMS = [
  { key: "desktop", icon: "💻" },
  { key: "mobile", icon: "📱" },
];

export const SPLIT_QUEUE_HINT =
  "Pages screenhunter can't capture get captured by hand in DWW Browser instead, and screenhunter stops capturing that platform while it's there.";

const isOpenJob = job =>
  !!job && (job.status === "pending" || job.status === "claimed");

// Where a platform's captures come from: by hand in DWW Browser (the split
// queue, promoted) or screenhunter's automatic runs.
const MANUAL = "Manual Capture Queue";
const AUTOMATIC = "Automatic Capture Queue";

// Moves one tracked URL's platforms between the two capture queues. The full
// version (URL screens page) is just a link per platform, its icon and the
// queue a click moves it to — which is all the state it shows; it loads
// /split-queue/state on mount and again after each move. The compact one (URLs
// list) starts from the row's <platform>_capture_source and only asks the API
// after an action.
class SplitQueueControl extends Component {
  state = {
    live: null,
    busy: null,
    error: null,
  };
  mounted = false;

  componentDidMount() {
    this.mounted = true;
    if (!this.props.compact) {
      this.refresh();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.setState({ live: null, error: null });
      if (!this.props.compact) {
        this.refresh();
      }
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  safeSetState = update => {
    if (this.mounted) {
      this.setState(update);
    }
  };
  refresh = () => {
    const { user, url } = this.props;
    // A state that won't load leaves the buttons off rather than guessing.
    return getSplitQueueState(user.token, url)
      .then(live => {
        this.safeSetState({ live });
      })
      .catch(err => {
        console.error("Loading the capture queue state failed", err);
      });
  };
  act = (platform, action) => e => {
    e.preventDefault();
    // A link can't be disabled, so a click while a move is in flight is
    // simply ignored.
    if (this.state.busy) {
      return;
    }
    const { user, url } = this.props;
    const question = `Move ${platform} to the ${
      action === "promote" ? MANUAL : AUTOMATIC
    }?`;
    if (!window.confirm(question)) {
      return;
    }
    const call =
      action === "promote" ? promoteToSplitQueue : releaseFromSplitQueue;
    this.setState({ busy: platform, error: null });
    call(user.token, url, platform)
      .catch(err => {
        // The full version shows no errors: the refresh below puts the button
        // back to where the platform really is. The compact one still says.
        console.error(`Moving ${platform} failed`, err);
        this.safeSetState({ error: err.message });
      })
      .then(this.refresh)
      .then(() => {
        this.safeSetState({ busy: null });
      });
  };
  isPromoted = platform => {
    const { live } = this.state;
    if (live && live[platform]) {
      return !!live[platform].promoted;
    }
    return isPromotedInRow(this.props.trackedUrl, platform);
  };
  renderCompact() {
    const { busy, error, live } = this.state;
    return (
      <span className="f7 ml2" title={SPLIT_QUEUE_HINT}>
        <span className="gray">Browser queue:</span>
        {PLATFORMS.map(({ key, icon }) => {
          const promoted = this.isPromoted(key);
          const job = live && live[key] ? live[key].job : null;
          const stuck = promoted && live && !isOpenJob(job);
          return (
            <span key={key} className="ml1">
              {icon}{" "}
              {promoted ? (
                <>
                  <b className={stuck ? "red" : "purple"}>
                    {stuck ? "stuck" : "in queue"}
                  </b>{" "}
                  <a href="#" onClick={this.act(key, "release")}>
                    return
                  </a>
                </>
              ) : (
                <a href="#" onClick={this.act(key, "promote")}>
                  send
                </a>
              )}
            </span>
          );
        })}
        {busy && <span className="gray ml1">&hellip;</span>}
        {error && <span className="red ml1">{error}</span>}
      </span>
    );
  }
  render() {
    if (this.props.compact) {
      return this.renderCompact();
    }
    const { live } = this.state;
    // Nothing until it's known where each platform is, and nothing for a URL
    // that isn't tracked — there is no queue to move it between.
    if (!live || !live.tracked) {
      return null;
    }
    return (
      <div className="flex flex-wrap justify-end">
        {PLATFORMS.map(({ key, icon }) => {
          // In the manual queue only while a job is open there. A promoted
          // platform whose job gave up offers the manual queue again, which
          // queues a fresh job.
          const info = live[key] || {};
          const manual = !!info.promoted && isOpenJob(info.job);
          return (
            <a
              key={key}
              href="#"
              className="ml3"
              title={`Move ${key} to the ${manual ? AUTOMATIC : MANUAL}`}
              onClick={this.act(key, manual ? "release" : "promote")}
            >
              {icon} {manual ? AUTOMATIC : MANUAL}
            </a>
          );
        })}
      </div>
    );
  }
}

export default SplitQueueControl;
